import React from 'react'
import { Formik } from 'formik'
import { ZariContext } from '_zari/context'
import { Button, Form, Modal } from '_zari/core'
import { EstadosTituloViaticos } from 'constants/index'
import * as UsuarioService from 'services/usuario.service'
import * as FormGroups from './formGroups'
import ValidationSchema from './validacion'

const InsertarActualizarModal = ({ show, handleClose, editarData, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      idUsuario: editarData.idUsuario ?? '',
      nombreUsuario: editarData.nombreUsuario ?? '',
      codigo: editarData.codigo ?? '',
      nombre: editarData.nombre ?? '',
      estado: editarData.estado ?? EstadosTituloViaticos.HABILITADO
    }
  }, [editarData])

  const onSubmit = React.useCallback(
  async (data, { setSubmitting }) => {
    try {
      // ✅ Obtener usuario logueado
      const { data: user } = await UsuarioService.obtenerUsuarioSelfIdNombresApellidos()
      const idUsuario = user._id

      // Construir payload con el idUsuario real
      const payload = {
        ...data,
        idUsuario,
        nombreUsuario: `${user.nombres} ${user.apellidos}`
      }

      const funcionSubmit = editarData._id
        ? () => UsuarioService.actualizarTituloViaticoxId(editarData._id, payload)
        : () => UsuarioService.nuevoTituloViatico(payload)

      await funcionSubmit()
      __zariContext.toast('success', 'El título viático se ha guardado con éxito.')
      reloadTable()
      handleClose()
    } catch (err) {
      const error = err?.data?.error ?? 'Error al guardar el título viático.'
      __zariContext.snack('error', error)
      setSubmitting(false)
    }
  },
  [__zariContext, editarData, reloadTable, handleClose]
)


  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>{editarData._id ? 'EDITAR TÍTULO VIÁTICO' : 'NUEVO TÍTULO VIÁTICO'}</Modal.Title>
      </Modal.Header>

      <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
        {({ errors, touched, values, isSubmitting, setValues, handleSubmit }) => (
          <>
            <Modal.Body>
              <Form>
                <FormGroups.TrabajadorFormGroup
                  iError={errors.idUsuario}
                  iTouched={touched.idUsuario}
                  fIsSubmitting={isSubmitting}
                  iValue={values.idUsuario}
                  setValues={setValues}
                  values={values}
                />
                <FormGroups.CodigoFormGroup
                  iError={errors.codigo}
                  iTouched={touched.codigo}
                  fIsSubmitting={isSubmitting}
                />
                <FormGroups.NombreFormGroup
                  iError={errors.nombre}
                  iTouched={touched.nombre}
                  fIsSubmitting={isSubmitting}
                />
                <FormGroups.EstadoFormGroup
                  iError={errors.estado}
                  iTouched={touched.estado}
                  fIsSubmitting={isSubmitting}
                />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button outline color='secondary' disabled={isSubmitting} onClick={handleClose}>
                Cancelar
              </Button>
              <Button disabled={isSubmitting} onClick={handleSubmit}>
                Guardar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(InsertarActualizarModal)
